import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'stage'

const StageModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default StageModule



// WEBPACK FOOTER //
// ./src/store/module/stage/index.js